import variantsApi from "@/api/variants";

// initial state
const state = {
  all: [],
  variant: null,
  groupKeys: [],
  groupVariants: []
};

// getters
const getters = {
  all: (state) => state.all,
  variant: (state) => state.variant,
  groupKeys: (state) => state.groupKeys,
  groupVariants: (state) => state.groupVariants,
  // GroupKey'e göre gruplanmış varyantlar
  variantsByGroup: (state) => {
    const grouped = {};
    state.all.forEach((variant) => {
      if (!grouped[variant.groupKey]) {
        grouped[variant.groupKey] = [];
      }
      grouped[variant.groupKey].push(variant);
    });
    return grouped;
  }
};

// actions
const actions = {
  // Tüm varyantları getir
  getAll: async (context) => {
    const response = await variantsApi.getAll();
    context.commit("setAll", response.data);
    return response.data;
  },

  // Belirli bir GroupKey'e ait varyantları getir
  getByGroupKey: async (context, groupKey) => {
    const response = await variantsApi.getByGroupKey(groupKey);
    context.commit("setGroupVariants", response.data);
    return response.data;
  },

  // ProductId'ye göre varyant getir
  get: async (context, productId) => {
    const response = await variantsApi.get(productId);
    context.commit("setVariant", response.data);
    return response.data;
  },

  // Tüm benzersiz GroupKey'leri getir
  getGroupKeys: async (context) => {
    const response = await variantsApi.getGroupKeys();
    context.commit("setGroupKeys", response.data);
    return response.data;
  },

  // Yeni varyant ekle
  post: async (context, variant) => {
    const response = await variantsApi.post(variant);
    if (response.data.success) {
      await context.dispatch("getAll");
    }
    return response.data;
  },

  // Varyant güncelle
  put: async (context, variant) => {
    const response = await variantsApi.put(variant);
    if (response.data.success) {
      await context.dispatch("getAll");
    }
    return response.data;
  },

  // Ana varyantı değiştir
  switchMajor: async (context, productId) => {
    const response = await variantsApi.switchMajor(productId);
    if (response.data.success) {
      await context.dispatch("getAll");
    }
    return response.data;
  },

  // Varyant sil
  delete: async (context, productId) => {
    const response = await variantsApi.delete(productId);
    if (response.data.success) {
      await context.dispatch("getAll");
    }
    return response.data;
  },

  // Varyant grubunu sil
  deleteGroup: async (context, groupKey) => {
    const response = await variantsApi.deleteGroup(groupKey);
    if (response.data.success) {
      await context.dispatch("getAll");
    }
    return response.data;
  },

  // State'i temizle
  clear: (context) => {
    context.commit("clear");
  }
};

// mutations
const mutations = {
  setAll(state, variants) {
    state.all = variants;
  },
  setVariant(state, variant) {
    state.variant = variant;
  },
  setGroupKeys(state, groupKeys) {
    state.groupKeys = groupKeys;
  },
  setGroupVariants(state, variants) {
    state.groupVariants = variants;
  },
  clear(state) {
    state.all = [];
    state.variant = null;
    state.groupKeys = [];
    state.groupVariants = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

